import { render, staticRenderFns } from "./description.vue?vue&type=template&id=4f2c9238&"
import script from "./description.vue?vue&type=script&lang=ts&"
export * from "./description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports